import * as React from 'react'
import gql from 'graphql-tag'
import styled from 'styled-components'
import { ChannelCardList_ChannelEdgeFragment } from 'generated/graphql'
import EmptyCard from '@app.feature/channel/channel.search/component/EmptyCard'
import ChannelCard from '@app.feature/channel/component/cards/ChannelCard/ChannelCard'
import ChannelCardLoading from '@app.feature/channel/component/cards/ChannelCard/ChannelCardLoading'
import { mobileBreakPoint } from 'app.styled/media'

gql`
  fragment ChannelCardList_ChannelEdge on ChannelEdge {
    cursor
    node {
      ...channelCard_channel
    }
  }
`

type Props = {
  data: ChannelCardList_ChannelEdgeFragment[]
  loading: boolean
  skeletonSize?: number
  className?: string
}

const ChannelList: React.FC<Props> = ({
  loading,
  data,
  skeletonSize = 3,
  className,
}) => {
  const skeletonArr = new Array(skeletonSize).fill('')

  return (
    <StyledWrapper className={className}>
      {loading && (
        <div className="channel-card-wrapper">
          {skeletonArr.map((_, idx) => (
            <div key={idx}>
              <ChannelCardLoading type="search" />
              {idx !== 4 && <div className="hr" />}
            </div>
          ))}
        </div>
      )}
      {data.length > 0 && (
        <div className="channel-card-wrapper">
          {data.map((edge, idx) => (
            <div key={edge.cursor}>
              <ChannelCard
                className="channel-card"
                type="SEARCH"
                data={edge.node}
              />
              {(data.length || 0) - 1 !== idx && <div className="hr" />}
            </div>
          ))}
        </div>
      )}
      {!loading && data.length === 0 && <EmptyCard />}
    </StyledWrapper>
  )
}

export default ChannelList

const StyledWrapper = styled.div`
  .channel-card-wrapper {
    border-radius: 5px;
    background-color: white;
    padding: 8px 28px;
    border: 1px solid #e8e8e8;
  }
  .hr {
    height: 1px;
    background-color: #f4f4f4;
  }
  ${mobileBreakPoint} {
    .hr {
      height: 1px;
      background-color: #f4f4f4;
    }
    .channel-card-wrapper {
      border: none;
      padding: 0px 20px;
      .channel-card {
        padding: 17px 0;
      }
    }
  }
`
